export default {
  tickets: [],
  audits: [],
  types: [
    { 
      text: 'Ambiental',
      subTypes: [
        'Olores', 
        'Ruido', 
        'Particulado', 
        'Agua',
        'Sedimentos',
        'Felicitaciones',
        'Sugerencia',
        'Sin valor'
      ]
    },
    { 
      text: 'Comunitario',
      subTypes: [
        'Temas Asuntos Corporativos',
        'Becas y Colaciones',
        'Fondo CMPC',
        'Fundación CMPC',
        'Charlas y Capacitaciones',
        'Paseo CMPC',
        'Sin valor'
      ]
    },
    { 
      text: 'Transporte',
      subTypes: [
        'Camiones Planta',
        'Vehiculos externos a planta',
        'Proveedores Planta',
        'Camiones Forestales',
        'Sin valor'
      ]
    },
    { 
      text: 'Consulta Ambiental',
      subTypes: [
        'Olores', 
        'Ruido', 
        'Particulado', 
        'Agua',
        'Sedimentos',
        'Felicitaciones',
        'Sugerencia',
        'Sin valor'
      ]
    },
    { 
      text: 'Ambiental no procedente',
      subTypes: [
        'Sin valor'
      ]
    },
  ],
  channels: ['Telefónica', 'Whatsapp', 'Facebook', 'Twitter', 'Mail', 'Presencial', 'AACC'],
  directions: ['Entrante', 'Saliente'],
  managers: [],
  managerInternals: [],
  states: {
    draft: { text: 'Borrador', color: 'secondary' },
    opened: { text: 'Abierta', color: 'secondary' },
    reviewed: { text: 'En revisión', color: 'info' },
    published: { text: 'Publicado', color: 'primary' },
    unanswered: { text: 'Sin respuesta', color: 'secondary' },
    invalid: { text: 'No procedente', color: 'secondary' },
    closed: { text: 'Cerrado', color: 'error' },
  },
  statusAudit: {
    info: {
      icon: 'mdi-information',
      color: 'info',
    },
    success: {
      icon: 'mdi-check-circle',
      color: 'success',
    },
    error: {
      icon: 'mdi-alert-circle',
      color: 'error',
    },
  }
}
